import React, { useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import { appI18n, getLanguageDir } from '../i18n/app';

interface AppI18nProviderProps {
  children: React.ReactNode;
}

const AppI18nProvider: React.FC<AppI18nProviderProps> = ({ children }) => {
  const [language, setLanguage] = useState(appI18n.language);

  useEffect(() => {
    const onLanguageChanged = (lng: string) => setLanguage(lng);
    appI18n.on('languageChanged', onLanguageChanged);
    return () => {
      appI18n.off('languageChanged', onLanguageChanged);
    };
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute('lang', language);
    document.documentElement.setAttribute('dir', getLanguageDir(language));
  }, [language]);

  return <I18nextProvider i18n={appI18n}>{children}</I18nextProvider>;
};

export default AppI18nProvider;
